<template>
    <div>
        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row justify-content-end">
                <div class="col-auto pt-2">
                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                </div>
                <div class="col-auto">
                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                </div>
            </div>
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <b-table small striped hover bordered :fields="fields" :items="voucherItems" responsive="sm">
                        <template #cell(index)="data">
                            {{ data.index + startPage }}
                        </template>
                        <template #cell(voucherName)="data">
                            <a class="text-primary fw-500 link" @click="viewVoucherDetails(data.item.voucherID, data.item.voucherName, data.item.total)">{{data.item.voucherName}}</a>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.voucher_balance')}}
                            <small class="m-0 text-muted">"{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="ml-auto mb-3 text-right">
                            <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                                :data="exportData"
                                :fields="exportFields"
                                :header="exportHeaders"
                                type="csv"
                                :escapeCsv="false"
                                :name="exportFileName">
                                <span>CSV</span>
                            </exportCSV>
                            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                                <span class="mr-3">PDF</span>
                                <i class="arrow-down fas fa-angle-down"></i> 
                            </button> -->
                        </div>
                        <div v-if="isBalanceSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isBalanceSpinnerShow && voucherBalanceItems.length == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isBalanceSpinnerShow && voucherBalanceItems.length != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table small striped hover bordered :fields="balanceFields" :items="voucherBalanceItems" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>
                                        <template #cell(amount)="data">
                                           {{formatPrice(data.item.amount)}}
                                        </template>
                                        <template #custom-foot>
                                            <b-tr>
                                                <b-th class="border-top-bottom-2 text-right fw-700" colspan="3">{{$t('label.total')}}</b-th>
                                                <b-th class="border-top-bottom-2 fw-500">{{totalAmount}}</b-th>
                                                <b-th class="border-top-bottom-2 fw-500">{{totalBalance}}</b-th>
                                            </b-tr>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {handleSessionExpired, setReturnData} from './../../../../assets/js/dashboard/dashboard.js'
import {formatPrice} from './../../../../assets/js/dashboard/utilities.js'
export default {
    name: "voucherSummaryVoucher",
    data(){
        return{
            isSpinnerShow: false, isBalanceSpinnerShow: false,
            toggleModal: false, sTitle: "",
            voucherItems: [], voucherBalanceItems: [],
            filterObj: {},
            totalBalance: 0, totalAmount: 0,
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "",
            voucherExportData: []
        }
    }, 
    computed:{
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle'},
                {key: "voucherName", label: this.$i18n.t('table.header.voucher'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "total", label: this.$i18n.t('table.header.balance'), thClass: 'thead-themed align-middle', sortable: true},
            ]
        },
        balanceFields(){
            return[
                {key: "index", label: "#"},
                {key: "memberDisplayName", label: this.$i18n.t('table.header.name'), sortable: true},
                {key: "mobile", label: this.$i18n.t('table.header.contact')},
                {key: "amount", label: this.$i18n.t('table.header.amount'), sortable: true},
                {key: "total", label: this.$i18n.t('table.header.balance'), sortable: true},
            ]
        },
        voucherExportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[this.$i18n.t('table.header.voucher').toUpperCase()] = "voucher"
            ret[this.$i18n.t('table.header.balance').toUpperCase()] = "balance"
            return ret
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[this.$i18n.t('table.header.name').toUpperCase()] = "name"
            ret[this.$i18n.t('table.header.contact').toUpperCase()] = "mobile"
            ret[this.$i18n.t('table.header.amount').toUpperCase()] = "amount"
            ret[this.$i18n.t('table.header.balance').toUpperCase()] = "balance"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            if(this.$parent.tab == 'voucher'){
                this.setExportData(this.voucherExportData)
                this.setVoucherDetailsExportData(this.voucherBalanceItems)
            }
        }
    },
    methods:{
        formatPrice(price){
            return formatPrice(price)
        },
        async setVoucherSummaryVoucher(filterObj){
            this.filterObj = filterObj;
            var endDateFilter = "&startCreateDate=0&endCreateDate=" + moment(filterObj.dateBalance.startDate).unix()
            var dateFilter = !filterObj.dateFilter ? "" : "&startExpiryDate=" + moment(filterObj.date.startDate).unix() + "&endExpiryDate=" + moment(filterObj.date.endDate).unix()
            var searchFilter = filterObj.searchVoucher == "" ? "" : "&search=" + filterObj.searchVoucher

            this.isSpinnerShow = true;
            let strFilter = endDateFilter + dateFilter + searchFilter;
            var result = await this.getVoucherBalance(strFilter);
            var retData = setReturnData(result, this.totalEntries, this.page)
            console.log(retData.result);
            this.voucherItems = retData.result;
            this.voucherItems.sort((a, b) => b.total - a.total);
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            this.isSpinnerShow = false;

            await this.getExportData( "?" + endDateFilter + dateFilter + searchFilter)
        },
        async getVoucherBalance(searchFilter){
            let $vm = this;

            let QUERY_STRING = "?page=" + this.page + searchFilter;
            const url =  this.$api.REPORT_VOUCHER + this.$api.REPORT_BALANCE + QUERY_STRING ;
            console.log(searchFilter)
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result;
                $vm.totalEntries = response.data.count;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.setVoucherSummaryVoucher(this.filterObj);
            }
        },
        async getExportData(strFilter){
            let $vm = this;

            const url =  this.$api.REPORT_VOUCHER + this.$api.REPORT_BALANCE + strFilter ;
            
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.voucherExportData = result
            this.setExportData(result)
        },
        setExportData(data){
            var strDate = moment(this.filterObj.dateBalance.startDate).format(this.$msg.CST.DATE_FORMAT)

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[0].text + ")" 
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('salon_report.view') + this.$i18n.messages[this.$i18n.locale].tab.reportVoucherSummaryType[1].text,
                " "];
            var exportFileName =  header.split(" ").join("_") + strDate + this.$msg.REPORT.CSV

            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    voucher: data[i].voucherName,
                    balance: data[i].total
                })
            }

            var exportObj = {
                data: exportData,
                fields: this.voucherExportFields,
                headers: exportHeaders,
                fileName: exportFileName
            }
            this.$emit('setExportData', exportObj)
        },
        async viewVoucherDetails(id, title, total){
            this.sTitle = title
            this.totalBalance = total
            this.toggleModal = true

            let $vm = this;
            let QUERY_STRING = "?voucherID=" + id;
            const url =  $vm.$api.REPORT_VOUCHER + $vm.$api.REPORT_BALANCE + QUERY_STRING ;
            
            this.isBalanceSpinnerShow = false;
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.voucherBalanceItems = response.data.result;
                $vm.voucherBalanceItems.sort((a, b) => b.total - a.total);
                $vm.isBalanceSpinnerShow = false;
                $vm.getTotalAmount($vm.voucherBalanceItems)
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.setVoucherDetailsExportData(this.voucherBalanceItems)
        },
        setVoucherDetailsExportData(data){
            var strDate = moment(this.filterObj.dateBalance.startDate).format(this.$msg.CST.DATE_FORMAT)

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[0].text + ")"  + "-" + this.$i18n.t('label.details') 
            this.exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                " "];
            this.exportFileName =  header.split(" ").join("_") + strDate + this.$msg.REPORT.CSV

            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    name: data[i].memberDisplayName,
                    mobile: data[i].mobile,
                    amount: data[i].amount,
                    balance: data[i].total
                })
            }
            exportData.push({
                index: "",
                name: "",
                mobile: "",
                amount: parseFloat(this.totalAmount.replace(/,/g, '')),
                balance: this.totalBalance
            })
            this.exportData = exportData
        },
        getTotalAmount(data){
            var total = 0
            for(var i=0; i<data.length; i++){
                total += data[i].amount
            }
            this.totalAmount = formatPrice(total)
        },
    }
}
</script>
<style scoped>
.link{
    cursor: pointer;
}
.show{
    display: block;
}
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
.modal-body{
    max-height: 80vh;
    min-height: 80vh;
    overflow-y: auto;
}
</style>